import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form, notification } from 'antd'
import _ from 'lodash'
import ButtonWhite from 'components/design/Form/ButtonWhite'
import ButtonBlack from 'components/design/Form/ButtonBlack'
import { loginWithProvider } from 'services/user'
import FormInput from '../../design/Form/Input'
import LinkPurple from '../../design/Form/LinkPurple'
import constants from '../../../constants'
import authStyle from '../../../layouts/Auth/style.module.scss'
import style from './style.module.scss'

const LoginForm = ({ footer }) => {
  const [form] = Form.useForm()
  const user = useSelector(state => state.user)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loadingProvider, setLoadingProvider] = useState(null)
  const dispatch = useDispatch()

  const onFinish = values => {
    if (values) {
      dispatch({
        type: 'user/LOGIN',
        payload: values,
        onComplete: afterLoginEvents,
      })
    } else {
      dispatch({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Invalid credentials! Please check email and password.',
        },
      })
    }
  }

  const afterLoginEvents = ({ error, cancelled, data }) => {
    if (!error && !cancelled && data.data) {
      if (constants.captureGTMEvents && window.CometChatAnalytics) {
        window.CometChatAnalytics.event(constants.GAEvents.user_login_otp_sent)
      }
    }
  }

  const handleEmailInput = e => {
    setEmail({ email: e.target.value })
  }
  const handlePasswordInput = e => {
    setPassword({ password: e.target.value })
  }

  const handleProviderLogin = async provider => {
    setLoadingProvider(provider)
    try {
      await loginWithProvider(provider)
    } catch (error) {
      notification.error({
        message: error.response.data.error.message,
        placement: 'bottomRight',
      })
    } finally {
      setLoadingProvider(null)
    }
  }

  return (
    <div className={style.cometchatLogin}>
      <div className={style.cometchatLoginContent}>
        <div className={style.loginFormTitle}>Welcome back</div>
        <div className={style.cometchatLoginActions}>
          <ButtonWhite
            buttonStyles={{ height: '44px' }}
            buttonText={
              <div className={style.cometchatLoginActionItem}>
                <div className={style.cometchatLoginGoogleIcon} />
                Sign in with Google
              </div>
            }
            buttonType="button"
            onClick={() => handleProviderLogin('google')}
            loading={loadingProvider === 'google'}
            disabled={loadingProvider !== null}
          />
          <ButtonWhite
            buttonStyles={{ height: '44px' }}
            buttonText={
              <div className={style.cometchatLoginActionItem}>
                <div className={style.cometchatLoginGithubIcon} />
                Sign in with GitHub
              </div>
            }
            buttonType="button"
            onClick={() => handleProviderLogin('github')}
            loading={loadingProvider === 'github'}
            disabled={loadingProvider !== null}
          />
        </div>
        <div className={style.cometchatLoginDivider}>
          <div className={style.cometchatLoginDividerLine} />
          Or
          <div className={style.cometchatLoginDividerLine} />
        </div>
        <div className={style.cometchatLoginForm}>
          <Form
            form={form}
            hideRequiredMark
            onFinish={onFinish}
            initialValues={{
              email: _.trim(user.prefilledLoginEmail).length > 0 ? user.prefilledLoginEmail : email,
              password,
            }}
            style={{ width: '100%' }}
          >
            <FormInput
              autoFocus
              onChange={handleEmailInput}
              Form={Form}
              label={<div className={style.cometchatLoginInputLabel}>Email</div>}
              style={{ height: '44px', borderColor: '#d5d7da' }}
              name="email"
              value={email}
              placeholder="Your work email"
              rules={[
                { required: true, message: 'Please enter your email' },
                {
                  type: 'email',
                  message: 'Please enter a valid email',
                },
              ]}
              disabled={_.trim(user.prefilledLoginEmail).length > 0}
            />
            <FormInput
              autoFocus={false}
              onChange={handlePasswordInput}
              Form={Form}
              label={
                <div className={style.cometchatLoginInputLabel}>
                  Password
                  <LinkPurple
                    to="/forgot-password"
                    linktext="Forgot password?"
                    classes={authStyle.resetPasswordLink}
                    linkHolderStyles={{
                      display: 'flex',
                      justifyContent: 'right',
                      marginRight: '1px',
                    }}
                  />
                </div>
              }
              style={{ height: '44px', borderColor: '#d5d7da' }}
              name="password"
              value={password}
              placeholder="Your password"
              rules={[{ required: true, message: 'Please enter your password' }]}
              type="password"
              formItemStyles={{ marginBottom: '4px' }}
            />
            <ButtonBlack
              buttonText="Log in"
              buttonType="submit"
              loading={user.loading}
              buttonStyles={{
                height: '44px',
                fontSize: '16px',
                marginTop: '24px',
              }}
            />
          </Form>
          <div className={style.cometchatLoginFooter}>
            <div className={style.cometchatLoginFooterText}>Don&apos;t have an account? </div>
            <div>
              <LinkPurple to="/signup" linktext="Sign up" classes={style.logInLink} />
            </div>
          </div>
        </div>
      </div>
      {footer}
    </div>
  )
}

export default LoginForm
